import React, { useCallback, useEffect, useRef, useState } from 'react'
import { PerfilButton } from "./PerfilButton";
import microuniversoApi from "../../api/microuniversoApi";
import { Vendedor } from "../../types/Vendedor";
import store from 'app/redux/store/store';
import globalMU from 'globalMU';
import { limparInformacoesOrcamentoAction } from 'app/redux/orcamentoSlice';
import { limparOrcamentoEmAndamentoAction } from 'app/redux/orcamentoEmAndamentoSlice';
import { limparProdutosSelecionadosAction } from 'app/redux/produtosSelecionadosSlice';
import { gravarTelasAlteradasSalvaAction } from 'app/redux/telaOrcamentoAlteradaNaoSalvaSlice';

export const PerfilButtonContainer = () => {
    const [vendedorLogado, setVendedorLogado] = useState<Vendedor>(null)
    const isMounted = useRef<boolean>(true)

    const obterVendedor = useCallback(async () => {
        const vendedor = await microuniversoApi.Vendedor.ObterVendedorAutenticado()

        if (isMounted.current) {
            setVendedorLogado(vendedor)
        }
    }, [])

    useEffect(() => {
        isMounted.current = true
        obterVendedor()

        return () => {
            isMounted.current = false
        }
    }, [obterVendedor])

    const confirmarAbandonoDoOrcamento = useCallback(async () => {
        if (!globalMU.existeOrcamentoEmAndamento()) {
            return true
        }

        const orcamentoConcluido = sessionStorage.getItem('orcamentoConcluido') == "true" //467485
        return orcamentoConcluido || window.confirm(`Existe um orçamento em andamento, se prosseguir este orçamento será perdido.\n\n Continuar? `)
    }, [])

    const fazerLogout = useCallback(async () => {
        const state = store.getState?.()
        const numeroPedidoEditando = state?.orcamento?.Numero ?? 0
        const somenteLeitura = numeroPedidoEditando != undefined ? state?.orcamento?.SomenteLeitura : false

        if (numeroPedidoEditando != undefined && !somenteLeitura && globalMU.existeOrcamentoEmAndamento()) {
            const sair = await confirmarAbandonoDoOrcamento()
            if (!sair) {
                return
            }

            try
            {
                if (numeroPedidoEditando > 0){
                    await microuniversoApi.Orcamento.RemoverControleExclusividade(numeroPedidoEditando, true) // 458014
                }

                store.dispatch(gravarTelasAlteradasSalvaAction("telaEntrega_entrega"))// 458014
                store.dispatch(gravarTelasAlteradasSalvaAction("telaEntrega_transportadora"))// 458014
                store.dispatch(gravarTelasAlteradasSalvaAction("telaEntrega_tipoEntrega"))// 458014
                store.dispatch(gravarTelasAlteradasSalvaAction("telaEntrega_frete"))// 458014
                store.dispatch(gravarTelasAlteradasSalvaAction("telaResumoOrcamento"))// 458014
            } catch (error) {
                console.log(error)
            }

            try
            {
                store.dispatch(limparInformacoesOrcamentoAction()) // 458014

                // 491123 — logout com "sair" confirmado é abandono consciente do orçamento em
                // andamento: limpa também o snapshot persistido (orcamentoEmAndamento/cesta), já
                // que essas duas slices não escutam mais limparInformacoesOrcamentoAction em
                // cascata (ver orcamentoEmAndamentoSlice.ts/produtosSelecionadosSlice.ts).
                store.dispatch(limparOrcamentoEmAndamentoAction())
                store.dispatch(limparProdutosSelecionadosAction())
            } catch (error) {
                console.log(error)
            }
        }

        window.location.href = `/Vendedor/Sair?XAbaId=${sessionStorage.getItem('aba_id')}`
    }, [confirmarAbandonoDoOrcamento])

    if (!vendedorLogado?.Codigo) {
        return null
    }

    return <PerfilButton
        key={vendedorLogado.Codigo}
        vendedorLogado={vendedorLogado}
        onLogoutClick={fazerLogout}
    />
}

(window as any).PerfilButtonContainer = PerfilButtonContainer
